module.exports = __webpack_public_path__ + "static/img/mjcafe-g.2b4c2b68.png";